import { Button } from '@village/ui';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { termsOfUseEnglish, termsOfUseSpanish } from './content';
import * as Styled from './styles';

interface Props {
    open: boolean;
    onClose: () => void;
}

export const TermsOfUseModal: FC<Props> = ({ open, onClose }) => {
    const { t, i18n } = useTranslation();

    return (
        <Styled.Modal open={open} onClose={onClose} hideCloseButton>
            <Styled.ModalWrapper>
                <Styled.ModalHeaderSection>
                    <Styled.Content
                        type="body2"
                        dangerouslySetInnerHTML={{
                            __html: i18n.language === 'es' ? termsOfUseSpanish : termsOfUseEnglish,
                        }}
                    />
                </Styled.ModalHeaderSection>
                <Styled.FooterSection>
                    <Button onClick={onClose} size="large" fullWidth>
                        {t('termsOfUseModal.done')}
                    </Button>
                </Styled.FooterSection>
            </Styled.ModalWrapper>
        </Styled.Modal>
    );
};
